export const errorStyle: string = 'background: #F72928; color: white; padding: 4px 12px; border-radius: 2px';
export const successStyle: string = 'background: #29B62E; color: white; padding: 4px 12px; border-radius: 2px';
export const warningStyle: string = 'background: #E6BE25; color: white; padding: 4px 12px; border-radius: 2px';
